module.exports = __webpack_public_path__ + "img/tabbed-search-filter-v-search-bar-luxury.787f53bb.png";